// extracted by mini-css-extract-plugin
export default {"paragraphWithReadMore__button":"ParagraphWithReadMore_paragraphWithReadMore__button__5NWSW"};